<template>
  <div class="cx-row--nogutter">
    <nav class="cx-col-md-3" v-if="hasTripLink()">
      <router-link-localed
        class="cx-t01 m-collapse__header"
        to="/macao-full-of-fun">
        {{$t('trip.trips')}}
      </router-link-localed>
      <template v-for="i in 5">
        <component 
          v-if="$te(`trip.menuItem${i}Link`) && $t(`trip.menuItem${i}Link`)"
          :key="$t(`trip.menuItem${i}Label`)"
          :is="''"
          class="m-collapse__link"
          v-bind="linkProps($t(`trip.menuItem${i}Link`))"
        >
          <i class="fas fa-angle-right"></i>
          {{$t(`trip.menuItem${i}Label`)}}
        </component>
      </template>
    </nav>
    <template v-if="travelEssentialMenu && travelEssentialMenu.length > 0">
      <nav :class="menuClass" 
        v-for="group in travelEssentialMenu" 
        :key="group.id">
        <router-link-localed 
          :to="`/travelessential#${group.id}`" 
          class="cx-t01 m-collapse__header">
          {{group.name | toUpperCase}}
        </router-link-localed>
        <component v-for="item in group.items" 
          :key="item.name"
          :is="''"
          v-bind="linkProps(item.link 
            ? item.link 
            : (['before-you-travel', 'about-macao', 'useful-info'].includes(item.category)
              ? `/travelessential/${item.category}/${item.slug}`
              : `/article/${item.category}/${item.slug}`)
          )"
          class="m-collapse__link">
          <i class="fas fa-angle-right"></i>
          {{item.name}}
        </component>
      </nav>        
    </template>
    <cx-img
      tag="div"
      class="m-collapse__graphic m-collapse__planyourtrip m-graphic--planyourtrip"
      :imgSrc="$i18n.locale == 'ar' ? '/static/graphic/mgto_graphic_menu_planyourtrip_v1-ar.png' : '/static/graphic/mgto_graphic_menu_planyourtrip_v1.png'"
      :imgHolder="false"
    ></cx-img>
  </div>
  <!-- header end -->
</template>

<script>

export default {
  name: 'main-header-collapse-plan-your-trip',
  uit() {
    return [
      ['trip', [
        'trips',
        'suggestedTour',
        'menuItem1Label',
        'menuItem1Link',
        'menuItem2Label',
        'menuItem2Link',
        'menuItem3Label',
        'menuItem3Link',
        'menuItem4Label',
        'menuItem4Link',
        'menuItem5Label',
        'menuItem5Link',
        // 'planner',
      ]],
      // ['followTheStar', [
      //   'followTheStar'
      // ]],
    ]
  },
  computed: {
    menuClass: function() {
      return this.hasTripLink() ? 'cx-col-md-3' : 'cx-col-md-4';
    }
  },
  methods: {
    hasTripLink: function() {
      return Array.apply(null, Array(5)).some((_, idx) => {
        return this.$te(`trip.menuItem${idx + 1}Link`) 
          && this.$t(`trip.menuItem${idx + 1}Link`)
      })
    },
  },
  props: {
    travelEssentialMenu: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">

</style>
